import GridErrorSplash from './grid-error-splash';

export default GridErrorSplash;